import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M8.827,12.349c0.621-1.409,1.796-2.313,3.399-2.615c0.268-0.049,0.553-0.075,0.852-0.075c0.439,0,0.877,0.065,1.296,0.149' +
                    'c0.163-0.648,0.505-1.463,1.169-2.217l0.461-3.222c0.113-0.789-0.447-1.435-1.244-1.435H3.531c-0.797,0-1.342,0.643-1.211,1.43' +
                    'l2.06,12.354c0.131,0.785,0.89,1.428,1.687,1.428h2.957C8.325,16.354,8.042,14.129,8.827,12.349z M4.218,6.936L3.792,4.382h10.745' +
                    'L14.1,7.447c-0.529,0.129-1.379,0.285-2.418,0.285c-1.765,0-2.988-1.115-4.528-1.115C6.12,6.617,4.907,6.695,4.218,6.936z"/>' +
                  '<path d="M16.783,8.393c1.113-1.118,2.564-1.101,2.564-1.101s0.012,1.448-1.104,2.566c-1.114,1.117-2.563,1.103-2.563,1.103' +
                    'S15.669,9.51,16.783,8.393z"/>' +
                  '<path d="M21.115,18.879c-1.539,2.482-2.494,2.791-3.143,2.788c-0.855-0.004-1.287-0.062-1.91-0.64' +
                    'c-0.621,0.578-1.058,0.636-1.912,0.64c-0.646,0.003-1.602-0.306-3.139-2.788c-1.463-2.359-2.161-7.015,1.487-7.701' +
                    'c1.511-0.283,3.564,0.721,3.564,0.721s2.057-1.004,3.568-0.721C23.277,11.864,22.576,16.52,21.115,18.879z"/>',
    }
  },
}